import api from '@/api';
import { ResponsePromise, ResponsePagePromise } from '@/api/interface';
import { GATEWAY } from '@/api/config';
import {
  ILikePayload,
  ICommentPayload,
  ICommentItem,
  IDeptTreeItem,
  ISearchUserParams,
  IL10NResponse,
} from './interface';
import { IUserInfo } from '../auth';

export default {
  // 公共-关键词搜索员工
  searchUser: (params: ISearchUserParams): ResponsePagePromise<IUserInfo> =>
    api.get(`${GATEWAY}/user/searchUser`, params),
  // 查询用户关注点赞信息
  getUserLikeInfo: (userId?: number): ResponsePromise<IUserInfo> =>
    api.get(`${GATEWAY}/user/popularity`, { userId }),
  getTipInfo: (tipType: number): ResponsePromise<boolean> =>
    api.get(`${GATEWAY}/common/tip`, { tipType }),
  muteTip: (tipType: number) => api.post(`${GATEWAY}/common/tip`, { tipType }),
  // 点赞 recordType: 记录类型 1浏览。2点赞
  thumbUp: (payload: ILikePayload) =>
    api.post(`${GATEWAY}/record/create`, { ...(payload || {}), recordType: 2 }),
  /**
   * 评论-新增评论
   */
  postComment: (payload: ICommentPayload) => api.post(`${GATEWAY}/comment/create`, payload),

  // 获取员工类型列表
  getEmpTypes: () => api.get(`${GATEWAY}/common/emp/types`),
  // 删除评论/回复
  deleteComment: (id: number) => api.delete(`${GATEWAY}/comment/delete`, { id }),
  /**
   * 获取进展评论列表 - 后端接口确定
   * @param params
   */
  getCommentList: (params: {
    targetId: number;
    targetType: string;
    userId?: number;
  }): ResponsePromise<ICommentItem[]> => api.get(`${GATEWAY}/comment/list`, params),
  /**
   * 公共-用户的部门树
   */
  getDeptTree: (parentId?: string): ResponsePromise<IDeptTreeItem[]> =>
    api.get(`${GATEWAY}/common/deptTree`, { parentId }),
  /**
   * 组织OKR-部门树
   */
  getOrganizationDeptTree: (parentId?: string): ResponsePromise<IDeptTreeItem[]> =>
    api.get(`${GATEWAY}/common/group/okr/deptTree`, { parentId }),

  /**
   * 共享中心-部门树
   */
  getShareCenterDeptTree: (parentId?: string): ResponsePromise<IDeptTreeItem[]> =>
    api.get(`${GATEWAY}/common/share/center/deptTree`, { parentId }),

  /**
   * 公共-用户的虚拟部门树
   */
  getVirDeptTree: (parentId?: string | number): ResponsePromise<IDeptTreeItem[]> =>
    api.get(`${GATEWAY}/common/virDeptTree`, { parentId }),
  // nos 获取 token
  getNosToken: (data: {
    objectName: string;
  }): ResponsePromise<{ bucketName: string; objectName: string; token: string }> =>
    api.get('/api/okr/nos/token', data),
  // nos 获取 url
  getNosUrl: (data: {
    objectName: string;
    fileName: string;
    fileNameEncode: string;
  }): ResponsePromise<{ url: string }> => api.get('/api/okr/nos/url', data),

  getLanguage: (data: any): ResponsePromise<IL10NResponse> =>
    api.get('/api/l10n4web/language', data), // 查询多个系统的翻译项
};

export * from './interface';
